import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import qs from 'qs';

import Pagination from '../components/Pagination/Pagination';
import { fetchAllTracfoneSubs } from '../actions/tracfoneSubs';
import { getAllTracfoneSubs, getPageCount } from '../reducers';
import OrderedSubList from '../components/OrderedSubList/OrderedSubList';

class AllTracfoneSubs extends Component {
  componentDidMount() {
    this.fetchTracfoneSubs();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.page !== this.props.page) {
      this.fetchTracfoneSubs();
    }

    if (oldProps.ordering !== this.props.ordering) {
      this.fetchTracfoneSubs();
    }
  }

  fetchTracfoneSubs() {
    const { fetchAllTracfoneSubs, page, ordering } = this.props;
    fetchAllTracfoneSubs(page, ordering);
  }

  handleChangeOrdering = (value) => {
    const { history } = this.props;
    history.push({
      search: `?ordering=${value}`,
    });
  };

  render() {
    const { subs, pageCount, page, ordering } = this.props;

    return (
      <div>
        <h1>All TracFone Subscriptions</h1>
        <OrderedSubList
          subs={subs}
          ordering={ordering}
          changeOrdering={this.handleChangeOrdering}
          statusKey="tracfone_status"
          viewUrl={(subId) => `/tracfone/subscriptions/${subId}/view`}
          showEffectiveDate
        />
        <Pagination
          count={pageCount}
          current={page}
          url={(pageNum) => `/tracfone/subscriptions/page/${pageNum}`}
        />
      </div>
    );
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { page = 1 },
    },
    location: { search },
  },
) => ({
  subs: getAllTracfoneSubs(state, page),
  pageCount: getPageCount(state, 'tracfoneSubs', 'fetchAll', page),
  page,
  ordering: qs.parse(search, { ignoreQueryPrefix: true }).ordering || '-id',
});

const mapDispatchToProps = {
  fetchAllTracfoneSubs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AllTracfoneSubs),
);
